import PropTypes from 'prop-types';
import {labels} from '../../../../../../util/utils';

function ScotItAppCount({scot, itApplications}) {
	//Keeps record of the it applications that were counted once.
	const countedItApps = {};

    const getCount = () => {
		scot.itApplications &&
			scot.itApplications.length > 0 &&
			scot.itApplications.map((itAppId) => {
				const itApp = itApplications.byId[itAppId];
                if (!countedItApps[itAppId] && !itApp.isServiceOrganization) {
                    countedItApps[itAppId] = true;
                }
			});

        const count = Object.keys(countedItApps).length;
        const itAppLabel = scot.hasNoITApplication ? '-' : labels.incomplete;
        return count > 0 ? count : itAppLabel;
	};

	return getCount();
}

ScotItAppCount.propTypes = {
	scot: PropTypes.shape({
		itApplications: PropTypes.arrayOf(PropTypes.number),
		controls: PropTypes.arrayOf(PropTypes.number),
		hasNoITApplication: PropTypes.bool
	})
};

export default ScotItAppCount;
